module.exports = __webpack_public_path__ + "static/media/tyrill-sample-carddeck.1b894c32.png";